import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import ReactDOM from "react-dom";
import "./CustomDropdownStyle.css";

const CustomDropdown = ({
  dropName,
  options,
  disabled,
  className,
  label,
  isimp,
  onSelect,
  selectedOptionName,
  type,
  field,
  isError,
  erroMessage,
  tooltip
}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [menuStyle, setMenuStyle] = useState({});
  const dropdownRef = useRef(null);
  const menuRef = useRef(null);

  const handleToggleDropdown = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };

  const handleSelectOption = (option, e) => {
    e.preventDefault();
    setSelectedOption(option);
    onSelect(option, field);
    setIsOpen(false);
  };

  useEffect(() => {
    if (type === "program" || type === "batch" || type === "programList" || type === "batchList") {
      const initialOption = options.find(
        (option) => option.id === selectedOptionName
      );
      if (initialOption) {
        setSelectedOption(initialOption);
      }
    }
  }, [options, selectedOptionName]);

  // Position the portaled menu beneath the trigger
  useLayoutEffect(() => {
    if (!isOpen || !dropdownRef.current) return;
    const positionMenu = () => {
      if (!dropdownRef.current) return;
      const rect = dropdownRef.current.getBoundingClientRect();
      const menuWidth = Math.max(rect.width, 140);
      // Default: align under trigger, left edge to trigger left
      let left = rect.left;
      // If popover would overflow the right edge of viewport, align it right
      if (left + menuWidth > window.innerWidth - 12) {
        left = Math.max(12, rect.right - menuWidth);
      }
      setMenuStyle({
        position: "fixed",
        top: rect.bottom + 6,
        left,
        minWidth: menuWidth,
      });
    };
    positionMenu();
    window.addEventListener("scroll", positionMenu, true);
    window.addEventListener("resize", positionMenu);
    return () => {
      window.removeEventListener("scroll", positionMenu, true);
      window.removeEventListener("resize", positionMenu);
    };
  }, [isOpen]);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };
    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div
      title={tooltip}
      ref={dropdownRef}
      className={`customDropdownWrap flexbox ${isOpen && "active"} ${className}`}
    >
      {label && (
        <label>
          {label} {isimp && <span className="impRed">*</span>}
        </label>
      )}
      <div className="dropDrop flexbox" onClick={() => handleToggleDropdown()}>
        <div className="dropText">
          {selectedOption
            ? selectedOption.name
            : typeof dropName === "number"
              ? dropName
              : dropName?.length > 0
                ? dropName
                : "Select an option"}
        </div>
        {type !== "program" && type !== "batch" && (
          <svg
            width="10"
            height="5"
            viewBox="0 0 10 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.62 0.220703L5.81667 4.02404C5.3675 4.4732 4.6325 4.4732 4.18334 4.02404L0.380005 0.220703"
              fill="#525252"
            />
          </svg>
        )}
      </div>
      {isError && <span className="FormError">{erroMessage}</span>}

      {isOpen &&
        typeof document !== "undefined" &&
        ReactDOM.createPortal(
          <div
            ref={menuRef}
            className="dropMenuWindow dropMenuWindowPortal active"
            style={menuStyle}
          >
            {options?.map((item, index) => (
              <label
                className="dropMenu"
                key={index}
                onClick={(e) => {
                  handleSelectOption(item, e);
                }}
              >
                <input type="radio" name="radio" />
                <span className="menuList">{item.name}</span>
              </label>
            ))}
          </div>,
          document.body
        )}
    </div>
  );
};

export default CustomDropdown;
